module.exports = __webpack_public_path__ + "static/media/logo_w.c72cbada.svg";